import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as RemoveIcon } from '@assets/svg/ic-remove.svg';

import FileTypeIcon from '../FileTypeIcon/FileTypeIcon';
import style from './style.module.scss';

const FileItem = ({ file, removeFunc }) => {
  return (
    <div className={style.fileItemWrapper} key={uuidv4()} title={file.name}>
      <RemoveIcon className={style.removeIcon} onClick={removeFunc} />
      <FileTypeIcon file={file} />
      <span className={style.fileItemName}>{file.name}</span>
    </div>
  );
};

export default FileItem;
